import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";
import BG from "../assets/Blue.png";
import Image from "../assets/IAM-Advisory-7.png";
import Footer from "../components/Footer";
import "../utils/effectCSS/Effects.css";

const IAMManagedServices = () => {
  return (
    <>
      <Container
        fluid
        className="py-5"
        style={{
          backgroundImage: "url(" + BG + ")",
        }}
      >
        <div
          style={{
            height: "70px",
          }}
        ></div>
        <h2 className="text-center p-4">
          <b>IAM Managed Services</b>
        </h2>

        <hr
          className="d-flex justify-content-center"
          style={{
            width: "10%",
            border: "1.5px solid blue",
            margin: "0 auto",
          }}
        />

        <div className="mt-5">
          <Row>
            <Col lg={2} className="d-flex justify-content-end">
              <FaQuoteLeft
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>

            <Col lg={8}>
              <Container fluid className="text-center">
                <p
                  style={{
                    fontSize: "1.25rem",
                  }}
                >
                 Security and efficiency don’t have to be a trade-off. IAM Managed Services provide a Seamless Solution that handles the complexities of Identity Management, Freeing you to focus on the Growth, Strategy, and Success of your Business.
                </p>
              </Container>
            </Col>

            <Col
              lg={2}
              className="d-flex align-items-start justify-content-start"
            >
              <FaQuoteRight
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>
          </Row>
        </div>
        <Container>
          <Row className="mt-5">
            <Col className="d-flex" lg={6}>
              <img className="img-fluid" src={Image} alt="IAM" />
            </Col>
            <Col lg={6}>
              <Container
                style={{
                  backgroundColor: "#6495ED",
                  color: "white",
                  padding: "5rem 4rem",
                }}
              >
                <h3 className="">Why Choose IDM 360 Analytics for Managed IAM?</h3>

                <div className="mt-4">
                  <ListGroup className="border-0 bg-transparent ">
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Expertise and Experience: With years of experience in Identity and Access Management (IAM), We offers industry-leading solutions and expertise to secure your Organization’s Identity Landscape.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                     Proactive Security Measures: We don’t just respond to threats—we anticipate them. We proactively manages IAM systems, Identifying Potential Vulnerabilities and addressing them before they become risks.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Seamless Integration: Our IAM services integrate smoothly with your existing IT systems, minimizing disruption while enhancing security and streamlining identity and access management processes.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      24/7 Support and Monitoring: Our managed services include round-the-clock support and real-time monitoring, ensuring your IAM systems are always protected and functioning optimally.
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
        <Card className="bg-transparent border border-0 mb-5 text-black text-center">
          <Card.Body>
            <h3 className="text-center mb-4 p-5">
              <b>
                Scalable and Secure Access Management with
                IAM Managed Services
              </b>
            </h3>
            <hr
              className="d-flex justify-content-center"
              style={{
                width: "10%",
                border: "1.5px solid blue",
                margin: "0 auto",
              }}
            />
            <Container >
              <Row xs={1} lg={3}>
                <Col lg={2}></Col>
                <Col lg={8} className="mt-4">
                  <p
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    Whether you're operating in a Cloud, Hybrid, or On-Premise Environment, IDM 360 Analytics delivers IAM solutions that are both Secure and Agile, Empowering your Organization to stay ahead of evolving security challenges.
                  </p>
                  <p
                    className="mt-5"
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    With a focus on Flexibility, We ensure that your IAM systems grow alongside your Organization, Adapting to new Users, Systems, and Technologies.
		    We make Access Management Simpler, So your Teams can focus on what matters most - driving Business Growth and Enhancing User Experiences.
                  </p>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>

        <Container className="p-0">
          {/* First Row */}
          <Row className="justify-content-center g-3 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>IAM-as-a-Service</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  IDM 360 Analytics' IAM-as-a-Service, you gain the agility to scale your identity management as your business grows while maintaining strict Security 		  Standards. We simplify complex Identity Management Tasks, Providing seamless integration across your Organization’s Systems and Applications.
                </p>
              </Container>
            </Col>
          </Row>

          {/* Second Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                 We take a Comprehensive Approach, Overseeing everything from Strategy and Design to Ongoing Operations and Continuous Optimization. With proactive 		 Monitoring and Management, We minimize Risks, Optimize Performance, and Align your IAM operations with Business Objectives. With Expert Management of your IAM program, you gain the Agility to scale your Identity Solutions as your Business Evolves.
                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>IAM Program and Operations Management</h5>
              </Container>
            </Col>
          </Row>

          {/* Third Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>IAM Application Support and Maintenance</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Whether it's handling onboarding, migrations, or adapting to evolving mobile identity requirements. Our all-encompassing IAM Application Support and Maintenance service takes the burden off your team, ensuring your IAM systems run smoothly and efficiently. By choosing Expert Support, you unlock Streamlined Processes and Optimized Operations, Leaving you free to focus on your core Business.
                </p>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="mt-4">
        <Footer />
      </div>
    </>
  );
};

export default IAMManagedServices;
